import { linkify } from './linkify/linkify';

export const containsUrl = (url: string) => url && url[0] !== '#' && linkify.test(url);
